import { render, staticRenderFns } from "./AccountAccounts.vue?vue&type=template&id=2a855424&"
import script from "./AccountAccounts.vue?vue&type=script&lang=js&"
export * from "./AccountAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports